export interface AndroidChromeMeasurement {
  reportedTop: number;
  reportedBottom: number;
  screenHeight: number;
  innerHeight: number;
}

export interface AndroidChromeInsets {
  top: string;
  bottom: string;
}

/**
 * Extra padding is only needed when a system bar is drawn on top of the page.
 * If the WebView is already shorter than the screen by a status bar plus a
 * navigation bar, that footer sits outside the page and more padding stacks
 * a second bar.
 */
export function androidChromeInsets(measurement: AndroidChromeMeasurement): AndroidChromeInsets {
  const outside = Math.max(0, measurement.screenHeight - measurement.innerHeight);
  const footerAlreadyOutside = outside >= 56;

  if (footerAlreadyOutside) {
    return { top: '0px', bottom: '0px' };
  }

  const statusAlreadyOutside = outside >= 20;
  const top = statusAlreadyOutside
    ? 0
    : measurement.reportedTop > 0
      ? measurement.reportedTop
      : 24;
  const bottom = measurement.reportedBottom >= 16 ? measurement.reportedBottom : 48;

  return { top: `${top}px`, bottom: `${bottom}px` };
}
